import _classCallCheck from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component, PropTypes } from 'react';
import styles from '../../../build/styles';
import { getCallbacks } from '../../helper/helper';

var CardHeaderTitle =
/*#__PURE__*/
function (_Component) {
  _inherits(CardHeaderTitle, _Component);

  function CardHeaderTitle() {
    _classCallCheck(this, CardHeaderTitle);

    return _possibleConstructorReturn(this, _getPrototypeOf(CardHeaderTitle).apply(this, arguments));
  }

  _createClass(CardHeaderTitle, [{
    key: "createClassName",
    value: function createClassName() {
      return [styles.cardHeaderTitle, this.props.className].join(' ').trim();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement('p', _extends({}, getCallbacks(this.props), {
        style: this.props.style,
        className: this.createClassName()
      }), this.props.children);
    }
  }]);

  return CardHeaderTitle;
}(Component);

export { CardHeaderTitle as default };
CardHeaderTitle.propTypes = {
  style: PropTypes.object,
  children: PropTypes.any,
  className: PropTypes.string
};
CardHeaderTitle.defaultProps = {
  style: {},
  className: ''
};